/**
 * design-system/03-Typography.md §2, transcribed value for value.
 *
 * Line height is **absolute**, never a unitless multiplier. A multiplier is the one CSS habit that would
 * make the web's type drift away from the apps as the scale changes: Compose sets `lineHeight` directly
 * and SwiftUI computes `lineSpacing` from a target, and both are absolute.
 */
export type TypeStyle = {
  fontSize: string;
  lineHeight: string;
  fontWeight: number;
  letterSpacing?: string;
};

export const Type = {
  display: { fontSize: '34px', lineHeight: '40px', fontWeight: 700 },
  titleL: { fontSize: '26px', lineHeight: '32px', fontWeight: 700 },
  titleM: { fontSize: '21px', lineHeight: '28px', fontWeight: 700 },
  titleS: { fontSize: '18px', lineHeight: '24px', fontWeight: 600 },

  /** The task question. Child mode only. */
  instruction: { fontSize: '22px', lineHeight: '30px', fontWeight: 600, letterSpacing: '-0.1px' },

  bodyL: { fontSize: '18px', lineHeight: '26px', fontWeight: 400 },
  body: { fontSize: '16px', lineHeight: '24px', fontWeight: 400 },
  bodyS: { fontSize: '14px', lineHeight: '20px', fontWeight: 400 },
  label: { fontSize: '15px', lineHeight: '20px', fontWeight: 600 },

  /** Parent mode only — below the child-mode 18px floor on purpose. */
  caption: { fontSize: '13px', lineHeight: '18px', fontWeight: 400 },

  numeric: { fontSize: '17px', lineHeight: '24px', fontWeight: 600 },
} as const satisfies Record<string, TypeStyle>;

export type TypeStyleName = keyof typeof Type;

export const FONT_STACK =
  "'Nunito', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
